import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { ExpressionLanguageActionType, ExpressionLanguageStoreElement } from './ExpressionLanguageReducer.types';

const initialState = Immutable.fromJS({
  fetching: false,
  operators: null,
});

export const ExpressionLanguageReducer = handleActions(
  {
    RESPONSE_EXPRESSION_LANGUAGE: (state: ExpressionLanguageStoreElement, action: ExpressionLanguageActionType) =>
      state.merge(
        Immutable.fromJS({
          fetching: false,
          operators: Immutable.fromJS(action.payload.regular),
        })
      ),
    REQUEST_EXPRESSION_LANGUAGE: (state: ExpressionLanguageStoreElement) =>
      state.merge(
        Immutable.fromJS({
          fetching: true,
        })
      ),
    RESPONSE_EXPRESSION_LANGUAGE_FAILURE: (state: ExpressionLanguageStoreElement) =>
      state.merge(
        Immutable.fromJS({
          fetching: false,
        })
      ),
    // @ts-ignore
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);
